import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDeliveryTypes, fetchNextSteps } from '../fetch/lookup';
import isNil from 'lodash/isNil';
import { JSON_PARSE_ERROR } from './consts';

export const getDeliveryTypes = createAsyncThunk(
  'selects/getDeliveryTypesStatus',
  ({ dispatcherTerminal }, { rejectWithValue }) => fetchDeliveryTypes(dispatcherTerminal)
      .then(({ data }) => ({ deliveryTypes: data }))
      .catch((err) => rejectWithValue({ error: err })),
  {
    condition: (_, { getState }) => {
      const { selects } = getState();
      if (isNil(selects) || selects.isLoadingDeliveryTypes) {
        return false;
      }
    },
  },
);

export const getNextSteps = createAsyncThunk(
  'selects/getNextStepsStatus',
  (_, { rejectWithValue }) => fetchNextSteps()
      .then(({ data }) => ({ nextSteps: data }))
      .catch((err) => rejectWithValue({ error: err })),
  {
    condition: (_, { getState }) => {
      const { selects } = getState();
      if (isNil(selects) || selects.isLoadingNextSteps) {
        return false;
      }
    },
  },
);

const initialState = {
  deliveryTypes: [],
  isLoadingDeliveryTypes: false,
  deliveryTypesError: null,
  rateZones: [],
  isLoadingRateZones: false,
  rateZonesError: null,
  nextSteps: [],
  isLoadingNextSteps: false,
  nextStepsError: null
};

const selectsSlice = createSlice({
  name: 'selects',
  initialState,
  extraReducers: {
    [getDeliveryTypes.pending]: (state) => {
      state.isLoadingDeliveryTypes = true;
      state.deliveryTypesError = null;
    },
    [getDeliveryTypes.fulfilled]: (state, { payload: { deliveryTypes } }) => {
      state.deliveryTypes = deliveryTypes;
      state.isLoadingDeliveryTypes = false;
    },
    [getDeliveryTypes.rejected]: (state, { payload: { error } }) => {
      state.isLoadingDeliveryTypes = false;
      state.deliveryTypesError = error.message === JSON_PARSE_ERROR ? 'Error retrieving delivery types for select!' : error.message;
    },
    [getNextSteps.pending]: (state) => {
      state.isLoadingNextSteps = true;
      state.nextStepsError = null;
    },
    [getNextSteps.fulfilled]: (state, { payload: { nextSteps } }) => {
      state.nextSteps = nextSteps;
      state.isLoadingNextSteps = false;
    },
    [getNextSteps.rejected]: (state, { payload: { error } }) => {
      state.isLoadingNextSteps = false;
      state.nextStepsError = error.message === JSON_PARSE_ERROR ? 'Error retrieving next steps for select!' : error.message;
    },
  },
});

export default selectsSlice.reducer;
